import { CheckCircle2 } from 'lucide-react'

export function TicketDeliveryNotice() {
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-success-subtle bg-success-subtle p-5 sm:p-6">
      <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-success-foreground" />
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold text-success-foreground">
          Votre dossier est bien soldé
        </p>
        <p className="text-sm text-success-foreground/90">
          Vos billets seront disponibles et vous seront envoyés par email entre 45 et 30 jours avant
          le départ. Nous vous remercions pour votre confiance.
        </p>
      </div>
    </div>
  )
}
